import React, {useEffect} from 'react'
import PropTypes from 'prop-types';
import SiwzService from 'services/SiwzService';
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import Form from 'components/Form';
import DocumentsTables from 'components/complex/documentsTables/DocumentsTables';
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import ValidationShema from "constants/ValidationShema";
import {DemandValidationProvider} from 'context/DemandValidationContext';
import DemandValidationMessages from "components/DemandValidationMessages";
import makeStyles from "@material-ui/core/styles/makeStyles";
import HeaderService from "services/HeaderService";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}));

function Documents(
    {
        expanded,
        match,
        demandValidation,
    }) {

    const classes = useStyles();

    const demandId = match.params.id
    const currentDemandValidation = DemandValidation.SIWZ;
    const FORM_ID = DemandValidationKeys[currentDemandValidation];

    const section = demandValidation.find(x => x.section === currentDemandValidation);
    const siwzEditable = section ? !!section.siwzEditable : false;
    const repoEditable = section ? !!section.repoEditable : false;

    useEffect(()=> {
        HeaderService.get(demandId);
    },[demandId])

    const handleSubmit = () => SiwzService.save(demandId, currentDemandValidation);
    return (
        <div className={classes.root}>
            <>
                <Form
                    onSubmit={handleSubmit}
                    id={FORM_ID}
                    validationSchema={ValidationShema.any()}
                    afterSubmitFunc={() => {
                        if (isDemandModification()) {
                            ModificationService.isDemandChanged(demandId);
                        }
                    }}
                >
                    {() => (<>
                    </>)}
                </Form>
                <DemandValidationProvider value={currentDemandValidation}>
                    <DemandValidationMessages editable={siwzEditable || repoEditable} section={section}/>
                    <DocumentsTables
                        demandId={demandId}
                        siwzEditable={siwzEditable}
                        repoEditable={repoEditable}
                    />
                </DemandValidationProvider>
            </>
        </div>
    )
}

Documents.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(Documents));
